import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { useTheme } from 'styled-components';
import useAuth from '../../../hooks/useAuth';
import { useDispatch } from 'react-redux';
import DropDownIcon from '../../components/svgIcons/DropDownIcon';
import AddIcon from '../../components/svgIcons/AddIcon';
import SwitchCompanyIcon from '../../components/svgIcons/SwitchCompanyIcon';
import AddCompanyModal from '../../../features/Setting/ChildCompanies/components/AddCompanyModal';
import GearIcon from '../../components/svgIcons/GearIcon';
import TickIcon from '../../components/svgIcons/TickIcon';
import { useGetAllChildCompaniesQuery } from '../../../features/Setting/ChildCompanies/childCompaniesApiSlice';
import { useSelector } from 'react-redux';
import {
  getPagination,
  getPaginationPage,
} from '../../components/pagination/paginationSlice';
import isArray from 'lodash/isArray';
import { setAppendedToken } from '../../../features/auth/authSlice';
import { occyLs } from '../../../utils/localStorage';
import { setChildCompany } from '../../../features/Setting/ChildCompanies/ChildCompanyDataSlice';
import {
  PERMISSIONS,
  usePermissionActionGuard,
} from '../../../permission-system';

const ChildCompaniesDropdown = ({ profile }) => {
  const loginCompany = occyLs.getObject('account');
  const theme = useTheme();
  const { user } = useAuth();
  const { runIfAllowed } = usePermissionActionGuard();
  const [addCompanyModal, setAddCompanyModal] = useState(false);
  const initialFilters = {
    childCompanies: [],
    perPage: 5,
    page: 1,
    sortedColumn: { path: 'createdAt', order: 'DESC' },
    query: '',
  };
  const listing = {
    ...initialFilters,
    perPage: useSelector(getPagination),
    page: useSelector(getPaginationPage),
  };

  const { data: childCompaniesRes, refetch: refetchCompanies } =
    useGetAllChildCompaniesQuery(
      {
        perPage: 50,
        page: listing.page,
        query: listing.query && listing.query,
        statusId: 2,
        //   sort: listing.sortedColumn.path,
        //   sortDir: listing.sortedColumn.order,
      },
      {
        refetchOnMountOrArgChange: true,
      },
    );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = useState(false);
  const closeTimerRef = useRef(null);

  const openMenu = () => {
    if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    setMenuOpen(true);
  };

  const scheduleCloseMenu = () => {
    if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    closeTimerRef.current = setTimeout(() => setMenuOpen(false), 160);
  };

  useEffect(
    () => () => {
      if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    },
    [],
  );

  useEffect(() => {
    dispatch(setChildCompany({ refetchCompanies }));
  }, []);
  const userMenuItems = [
    {
      name: 'Switch Company',
      icon: <SwitchCompanyIcon size={18} color="currentColor" />,
      hasSubmenu: true,
      action: () => {},
    },
    {
      name: 'Settings',
      icon: <GearIcon size={17} color="currentColor" />,
      action: () => {
        navigate('/settings/company/child/companies');
      },
    },
  ];
  const li = document.querySelectorAll('li.dropdown a');
  const btn = document.querySelector('.nav-btn');
  const nav = document.querySelector('ul.nav');

  btn?.addEventListener('click', (e) => {
    nav.classList.toggle('toggle');
  });

  li.forEach((each) => {
    if (each.nextElementSibling !== null) {
      each.addEventListener('click', (e) => {
        if (window.innerWidth < 768) {
          e.target.parentElement.classList.toggle('active');
        }
      });
    }
  });
  let randomColorsComp = [
    theme.danger,
    theme.borderColor,
    theme.tagLightgray,
    theme.success,
    theme.interviewsuccess,
    theme.inputPlaceHolder,
    theme.tootipBg,
    theme.lightGreen,
    theme.funnelIndex3,
    theme.statusTagSent,
    theme.stageIconColor,
    theme.primaryLight2,
    theme.notesColorOverDue,
    theme.chartManual,
    theme.gold,
    theme.eventColor2,
    theme.eventGreen,
    theme.LineChartBorder,
    theme.darkRed,
    theme.funnelIndex4,
    theme.successColorSky,
    theme.doughplaceholderColor,
    theme.pyramidInterviewed,
    theme.bodyBg,
    theme.chartVacant,
    theme.scheduleSelfSlotInfoColor,
    theme.crystal,
    theme.defaultImage,
    theme.danger,
    theme.statusTagCompleted,
    theme.chartFilled,
    theme.notesColorCompleted,
    theme.blue,
    theme.eventColor1,
    theme.white,
    theme.headingColor,
    theme.inputBorder,
    theme.inputColor,
    theme.formSettingCardDesc,
    theme.primaryDark,
    theme.dotColor,
    theme.lightYellow,
    theme.teamLabelbg,
    theme.stagesDarkColor,
    theme.hintBg,
    theme.primary,
    theme.lightBoldBlack,
    theme.creditBg1,
    theme.notesColorSent,
    theme.interviewtimebg,
    theme.orange,
    theme.tagBlueColor,
    theme.pyramidOffered,
    theme.statusTagOverDue,
    theme.successLight,
    theme.tagLightYellow,
    theme.tuna,
    theme.green,
    theme.triggerIconColor,
    theme.dangerFailColor,
    theme.creditBg2,
    theme.berylGreen,
    theme.eventColor5,
    theme.statusTextColor,
    theme.noteTags,
    theme.borderLight,
    theme.skygreen,
    theme.LineChartDashes,
    theme.eventColor3,
    theme.textColor,
    theme.doughGraphtooltipTitle,
    theme.darkBrown,
    theme.InterviewFormikToolbar,
    theme.crystal,
  ];

  const ls = occyLs.getObject('token')?.split('|').shift();
  const switchAccount = (acc) => {
    if (acc?.isParent === 1) {
      dispatch(setAppendedToken(ls?.split('|')[0]));
    } else {
      dispatch(setAppendedToken(ls?.split('|')[0] + '|' + acc?.id));
    }
    navigate('/settings/accounts/profile');
    window.location.reload();
  };
  return (
    <>
      <ProfileDropDownStyle className="d-flex align-items-stretch">
        <div
          className={`account-img cursor-pointer ${
            !profile?.image ? 'default' : ''
          }`}
          onClick={() => navigate('settings/company/profile')}
        >
          <StyledChar className="char" color={randomColorsComp[0]}>
            {companyInitials(user?.company?.name)}
          </StyledChar>
        </div>

        <StyledNav>
          <nav>
            <ul className="nav">
              <li className={`drodown${menuOpen ? ' is-open' : ''}`}>
                <a href="#" className="heading">
                  <span className="company-name">{user?.company?.name}</span>
                  <span
                    className="chevron-hit"
                    onMouseEnter={openMenu}
                    onMouseLeave={scheduleCloseMenu}
                  >
                    <DropDownIcon
                      rotate="down"
                      className="ms-1 chevron"
                      color={theme?.secondary || '#dc601e'}
                    />
                  </span>
                </a>
                <ul
                  className="menu-panel"
                  onMouseEnter={openMenu}
                  onMouseLeave={scheduleCloseMenu}
                >
                  {userMenuItems.map((it) => (
                    <li
                      className={`dropdown ${it.hasSubmenu ? 'has-submenu' : ''}`}
                      key={it.name}
                    >
                      <div
                        className="menu-row"
                        onClick={() => it.action()}
                      >
                        <span className="menu-row-icon">{it.icon}</span>
                        <span className="menu-row-label">{it.name}</span>
                        {it.hasSubmenu ? (
                          <DropDownIcon
                            rotate="right"
                            size={12}
                            color="currentColor"
                            className="menu-row-chevron"
                          />
                        ) : null}
                      </div>
                      {it?.name === 'Switch Company' && it?.hasSubmenu && (
                        <ul className="submenu-panel">
                          {isArray(childCompaniesRes?.companies) &&
                            childCompaniesRes.companies.map((l, i) => (
                              <li
                                key={l.id || l.name}
                                className={`company-item ${
                                  user?.company?.id === l?.id ? 'is-active' : ''
                                }`}
                                onClick={() => switchAccount(l)}
                              >
                                <StyledChar
                                  className="char"
                                  color={randomColorsComp[i]}
                                >
                                  {companyInitials(l.name)}
                                </StyledChar>
                                <span className="company-item-name">{l?.name}</span>
                                {user?.company?.id === l?.id && (
                                  <TickIcon size={16} color="#fff" />
                                )}
                              </li>
                            ))}
                          {loginCompany?.company?.isParent === 1 && (
                            <li
                              className={`add-company-item ${
                                user?.accountType === 2 &&
                                user?.company?.isParent === 1
                                  ? 'd-none'
                                  : ''
                              }`}
                            >
                              <a
                                href="#"
                                className="add-company-btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  runIfAllowed(
                                    PERMISSIONS.CREATE_CHILD_COMPANY,
                                    () => setAddCompanyModal(true),
                                  );
                                }}
                              >
                                <AddIcon size={14} color="currentColor" />
                                <span>Add Company</span>
                              </a>
                            </li>
                          )}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              </li>
            </ul>
          </nav>
        </StyledNav>
      </ProfileDropDownStyle>
      <AddCompanyModal
        title={'Add Company'}
        show={addCompanyModal}
        onHide={() => {
          setAddCompanyModal(false);
        }}
        editChildCompanyData={undefined}
        editCompanyModal={false}
      />
    </>
  );
};

const companyInitials = (name = '') => {
  const parts = String(name)
    .split(/[\s\-_/]+/)
    .filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return String(name).substring(0, 2).toUpperCase() || '?';
};

const StyledChar = styled.div`
  background-color: ${(props) => props.color};
  color: #fff;
  border-radius: ${({ theme }) =>
    `${theme?.radiusSm || '8px'} 0 0 ${theme?.radiusSm || '8px'}`};
  width: 100%;
  height: 100%;
  min-width: 36px;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  font-size: 12px;
  font-weight: ${({ theme }) => theme?.fontWeightSemibold || 600};
  letter-spacing: 0.02em;
`;

const StyledNav = styled.div`
  min-width: 0;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 2;

  .heading {
    font-size: 13px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0 12px 0 10px;
    white-space: nowrap;
    color: ${({ theme }) =>
      theme?.dark ? theme.headingColor : theme.primary || '#0d2349'} !important;
    max-width: 160px;
    height: 36px;
    line-height: 1;

    .company-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .chevron-hit {
      display: inline-flex;
      align-items: center;
      flex-shrink: 0;
      padding: 4px;
      margin: -4px -4px -4px 0;
    }

    .chevron {
      flex-shrink: 0;
    }
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  > nav > ul.nav {
    display: flex;
    align-items: center;
  }

  ul li a,
  ul li {
    cursor: pointer;
    font-size: 14px;
    text-decoration: none;
  }

  ul li {
    display: block;
  }

  > nav > ul > li {
    position: relative;
  }

  ul ul {
    display: none;
  }

  > nav > ul > li > ul.menu-panel {
    background: ${({ theme }) => (theme?.dark ? theme?.surface || '#1b1b1b' : '#fff')};
    padding: 10px;
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    min-width: 248px;
    width: max-content;
    border-radius: 16px;
    box-shadow: 0 10px 28px rgba(13, 35, 73, 0.16) !important;
    z-index: 1100;
    border: 1px solid
      ${({ theme }) =>
        theme?.dark ? theme?.borderSubtle : 'rgba(13, 35, 73, 0.06)'};
  }

  > nav > ul > li.is-open > ul.menu-panel {
    display: block;
  }

  > nav > ul > li.is-open > ul.menu-panel::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 100%;
    width: 100%;
    height: 8px;
  }

  .dropdown {
    position: relative;
    padding: 0;
    background: transparent !important;
  }
  .has-submenu {
    padding-right: 16px;
    margin-right: -16px;
  }
  .dropdown + .dropdown {
    margin-top: 8px;
  }
  .dropdown:hover {
    background: transparent !important;
  }

  .menu-row {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 44px;
    padding: 10px 14px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
    color: ${({ theme }) =>
      theme?.dark ? theme?.headingColor : '#0d2349'};
    background: ${({ theme }) =>
      theme?.dark ? theme?.surfaceHover || '#252525' : '#fff'};
    border: 1px solid
      ${({ theme }) =>
        theme?.dark ? theme?.borderSubtle : '#ececec'};
  }

  .menu-row-icon {
    display: inline-flex;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    color: inherit;
  }

  .menu-row-label {
    flex: 1 1 auto;
    min-width: 0;
    color: inherit !important;
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    padding: 0 !important;
    background: transparent !important;
  }

  .menu-row-chevron {
    flex-shrink: 0;
    margin-left: 8px;
    color: inherit;
  }

  .has-submenu:hover > .menu-row {
    background: ${({ theme }) =>
      theme?.dark ? theme?.navItemActiveBg || '#0B0F14' : '#0d2349'};
    border-color: ${({ theme }) =>
      theme?.dark ? theme?.navItemActiveBg || '#0B0F14' : '#0d2349'};
    color: #fff;
  }

  .menu-row svg,
  .has-submenu:hover > .menu-row svg {
    color: inherit;
    stroke: currentColor;
  }

  ul li ul li ul.submenu-panel {
    position: absolute;
    top: 0;
    left: calc(100% + 8px);
    min-width: 268px;
    width: max-content;
    background: ${({ theme }) => (theme?.dark ? theme?.surface || '#1b1b1b' : '#fff')};
    padding: 10px;
    border-radius: 16px;
    box-shadow: 0 10px 28px rgba(13, 35, 73, 0.16) !important;
    border: 1px solid
      ${({ theme }) =>
        theme?.dark ? theme?.borderSubtle : 'rgba(13, 35, 73, 0.06)'};
    z-index: 1101;
    display: none;
    flex-direction: column;
    gap: 8px;
    max-height: 360px;
    overflow-y: auto;
  }

  .company-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 10px;
    min-height: 48px;
    border-radius: 12px;
    background: ${({ theme }) =>
      theme?.dark ? theme?.surfaceHover || '#252525' : '#fff'};
    box-shadow: ${({ theme }) =>
      theme?.dark ? 'none' : '0 1px 2px rgba(13, 35, 73, 0.06)'};
    color: ${({ theme }) =>
      theme?.dark ? theme?.headingColor : '#0d2349'};
  }
  .company-item:hover {
    background: ${({ theme }) =>
      theme?.dark ? '#2A2A2A' : '#f7f8fa'} !important;
  }
  .company-item.is-active,
  .company-item.is-active:hover {
    background: ${({ theme }) =>
      theme?.dark ? theme?.navItemActiveBg || '#0B0F14' : '#0d2349'} !important;
    color: #fff;
    box-shadow: none;
  }
  .company-item .char {
    width: 32px !important;
    height: 32px !important;
    min-width: 32px !important;
    border-radius: 8px !important;
  }
  .company-item-name {
    flex: 1 1 auto;
    min-width: 0;
    font-size: 14px;
    font-weight: 600;
    color: inherit !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .company-item svg {
    flex-shrink: 0;
    margin-left: 4px;
  }

  .add-company-item {
    margin-top: 4px;
    padding-top: 8px;
    border-top: 1px solid
      ${({ theme }) =>
        theme?.dark ? theme?.borderSubtle : '#ececec'};
    background: transparent !important;
    box-shadow: none !important;
  }
  .add-company-btn {
    display: flex !important;
    align-items: center;
    gap: 10px;
    width: 100%;
    min-height: 44px;
    padding: 10px 14px !important;
    border-radius: 12px;
    background: ${({ theme }) =>
      theme?.dark ? '#2A2A2A' : '#f3f4f6'} !important;
    color: ${({ theme }) =>
      theme?.dark ? theme?.textSecondary : '#9c9c9c'} !important;
    font-size: 14px;
    font-weight: 600;
  }
  .add-company-btn:hover {
    background: ${({ theme }) =>
      theme?.dark ? '#333' : '#ececef'} !important;
    color: ${({ theme }) =>
      theme?.dark ? theme?.headingColor : '#6b7280'} !important;
  }
  .add-company-btn span {
    padding: 0 !important;
    color: inherit !important;
    background: transparent !important;
  }

  .has-submenu::after {
    content: '';
    position: absolute;
    top: 0;
    left: 100%;
    width: 18px;
    height: 100%;
    min-height: 220px;
  }

  .has-submenu:hover > ul.submenu-panel,
  .has-submenu:active > ul.submenu-panel {
    display: flex;
  }
`;

const ProfileDropDownStyle = styled.div`
  background-color: ${({ theme }) => (theme?.dark ? theme?.darkTileBg : '#fff')};
  border: none;
  border-radius: ${({ theme }) => theme?.radiusSm || '8px'};
  padding: 0;
  height: 36px;
  max-width: 260px;
  overflow: visible;
  box-shadow: 0 1px 2px rgba(13, 35, 73, 0.08);
  position: relative;
  z-index: 100;

  .menu-toggle {
    padding-block: 0;
  }

  .account-img {
    width: 36px;
    height: 36px;
    border-radius: ${({ theme }) =>
      `${theme?.radiusSm || '8px'} 0 0 ${theme?.radiusSm || '8px'}`};
    display: flex;
    align-items: stretch;
    flex-shrink: 0;
    overflow: hidden;

    &.default {
      background-color: transparent;
      color: ${({ theme }) => theme.white};
      display: flex;
      align-items: stretch;
      justify-content: center;
    }

    img {
      width: 36px;
      height: 36px;
      object-fit: cover;
    }
  }
`;
export default ChildCompaniesDropdown;
